const FormDataGenerator = object => {
  const FData = new FormData()
  for (let key in object)
    FData.append(key, object[key])

  return FData;
}

export default FormDataGenerator;